module.exports = __webpack_public_path__ + "img/superlever-cardIcon3.aa65d480.svg";